import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';

import AccordionToggle from '../../components/AccordionToggle';
import LightBoxPhotoList from '../../components/LightBoxPhotoList';
import { UnderdogCenter } from '../../helpers/UIElements';

const styles = css`
.CommunityPhotos_title {
  display: none;
  @media(min-width: 992px) {
    border-bottom: 0;
    text-transform: uppercase;
    background-color: transparent;
    background-image: none;
    font-weight: 700;
    font-size: 21px;
    color: #212121;
    letter-spacing: 5px;
    text-align: center;
    line-height: 32px;
    position: relative;
    display: inherit;
    flex-direction: column;
    padding: 0 20px;
    }
  }
`;

function CommunityPhotos({ community }) {
  return (
    <div className={styles}>
      <div id="photos" className="CommunityPhotos_scrollTarget" />
      <AccordionToggle
        openOnId="photos"
        button={({ contentVisible }) => (
          <div className="DetailsSection_btn d-lg-none" role="button" tabIndex={0}>
            <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Photo Gallery</h3>
          </div>
        )}
      >
        <div className="container">
          <UnderdogCenter className="d-none d-lg-block">
            <h3 className="CommunityPhotos_title">Photo Gallery</h3>
          </UnderdogCenter>
          <LightBoxPhotoList
            show={12}
            photos={get(community, 'photos')}
          />
        </div>
      </AccordionToggle>
    </div>
  );
}

CommunityPhotos.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunityPhotos;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityPhotos.js